type UseModal = {
  /**
   * The currently active modal ID.
   */
  activeModal: WritableComputedRef<string>

  /**
   * Close the modal.
   */
  closeModal: () => void
}

type UseModalWithId = {
  /**
   * Open the modal.
   */
  openModal: () => void

  /**
   * Close the modal.
   */
  closeModal: () => void

  /**
   * The modal ID.
   */
  modalId: string
}

/**
 * Use the composable for a specific modal ID.
 */
export function useModal(modalId: string): UseModalWithId

/**
 * Use the generic composable without a specific modal ID.
 */
export function useModal(): UseModal

/**
 * Keeps track of which modal is currently open.
 */
export function useModal(modalId?: string): UseModal | UseModalWithId {
  const activeModal = useQueryString('modal')

  function closeModal() {
    activeModal.value = ''
  }

  if (modalId) {
    return {
      openModal() {
        activeModal.value = modalId
      },
      closeModal,
      modalId,
    }
  }

  return {
    activeModal,
    closeModal,
  }
}
